export const billingConstants = {
  INVOICES_LOADED: 'INVOICES_LOADED',
  INVOICE_LOADED: 'INVOICE_LOADED',
  INVOICE_CREATED: 'INVOICE_CREATED',
  INVOICE_UPDATED: 'INVOICE_UPDATED',
  INVOICE_DELETED: 'INVOICE_DELETED',
  INVOICE_ERRORS: 'INVOICE_ERRORS',
  INVOICE_RESET: 'INVOICE_RESET',

  PAYMENTS_LOADED: 'PAYMENTS_LOADED',
  PAYMENT_LOADED: 'PAYMENT_LOADED',
  PAYMENT_CREATED: 'PAYMENT_CREATED',
  PAYMENT_UPDATED: 'PAYMENT_UPDATED',
  PAYMENT_DELETED: 'PAYMENT_DELETED',
  PAYMENT_ERRORS: 'PAYMENT_ERRORS',
  PAYMENT_RESET: 'PAYMENT_RESET'
};



// WEBPACK FOOTER //
// ./src/_constants/billing.constants.js